import { render } from "./Textcampaigndetail.vue?vue&type=template&id=a2969eca"
import script from "./Textcampaigndetail.vue?vue&type=script&lang=js"
export * from "./Textcampaigndetail.vue?vue&type=script&lang=js"

import "./Textcampaigndetail.vue?vue&type=style&index=0&id=a2969eca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__